import assignmentService from 'ApiService/Student/assignmentService';
import TestComponent from '../Index';

const Index = () => {
  const title = 'No Montly Assignment Assigned Yet.';
  const fetchMontlyAssignment = async () => {
    return await assignmentService.getMonthlyAssignment();
  };
  return <TestComponent fetchTests={fetchMontlyAssignment} NoData={title} />;
};

export default Index;
